import React from 'react';
import { faCompressAlt } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const MergeIcon = () => (
  <Icon tooltip="Merge" iconObj={faCompressAlt} />
);

export default MergeIcon;